import { render } from "./MortgagePage.vue?vue&type=template&id=21433ee0&scoped=true"
import script from "./MortgagePage.vue?vue&type=script&lang=js"
export * from "./MortgagePage.vue?vue&type=script&lang=js"

import "./MortgagePage.vue?vue&type=style&index=0&id=21433ee0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21433ee0"]])

export default __exports__